import React from 'react'

// logos
import headerLogoX3 from './img/dallas-boyer-bar-logo-336x63.png'
import headerLogoX2 from './img/dallas-boyer-bar-logo-224x42.png'

// banners
import terminalBannerDim from './img/dallas-boyer-terminal-screenshot-banner-dimmed.jpg'

// images
import analyticsWebAppScreenshot from './img/analytics-web-app-developed-by-dallas-boyer.jpg'
import commentForumWebAppScreenshot from './img/comment-forum-web-app-developed-by-dallas-boyer.jpg'
import bookTrackingWebAppScreenshot from './img/book-tracking-web-app-developed-by-dallas-boyer.jpg'
import flashcardsPhoneAppMockup from './img/flashcards-phone-app-wireframe-designed-by-dallas-boyer.png'
import techLogos from './img/web-development-technology-logos.png'
import profilePic from './img/dallas-boyer-profile-pic.jpg'

// theme colors
import indigo from 'material-ui/colors/indigo'
import teal from 'material-ui/colors/teal'
import red from 'material-ui/colors/red'

const currentYear = new Date().getFullYear();

// custom components
import Test from './custom-components/Test'
import ReactJsListItem from './custom-components/ReactJsListItem'
import JavascriptES6andBeyondListItem from './custom-components/JavascriptES6andBeyondListItem'
import ReactNativeListItem from './custom-components/ReactNativeListItem'
import InfoSectionDescription1 from './custom-components/InfoSectionDescription1'
import InfoSectionDescription2 from './custom-components/InfoSectionDescription2'

// NOTES for reference: https://www.npmjs.com/package/@fortawesome/react-fontawesome
import {
  // ListSection icons
  faCode,

  faEnvelope,

  // Header icons
  faHome,
  faUser,
  faPhone,
  faSignInAlt,

  // Menu icons
  faBars,
  faTimes
} from '@fortawesome/fontawesome-free-solid'

export default {
  title: 'Dallas Boyer Web Development',
  colorScheme: {
    darkTheme: {
      primaryColor: "#304FFE",
      secondaryColor: '#1DE9B6',
      errorColor: red,
    },
    lightTheme: {
      primaryColor: "#304FFE",
      secondaryColor: '#1DE9B6',
      errorColor: red,
    },
  },
  menu: {
    openIcon: faTimes,
    closeIcon: faBars,
  },
  contactForm: {
    actionURL: 'https://awd-email-system.herokuapp.com/send',
    sendingEmail: 'websitecontactform@renocarsonwebdesign.com',
    recaptchaSiteKey: "6LeKeV0UAAAAANqy-evLSWdEzHk-OFaEloEhnWNK"
  },
  business: {
    name: `All Web Development`,
    email: `form@renocarsonwebdesign.com`,
    phoneNumber: 7757819261,
    hrsOfOperation: {
      open: '7am',
      close: '5pm',
      timezone: 'PST',
    },
    copyrightStartDate: `2014`,
  },
  developer: {
    email: 'webmaster@renocarsonwebdesign.com', // NOTE currently unused
    site: 'https://dallasboyer.com',
    company: 'All Web Development'
  },
  headerLogo: {
    large: {
      image: headerLogoX3,
      width: 336,
      height: 63,
      horiPadding: 40,
      verticalPadding: 20,
      altText: 'Logo of freelance web developer Dallas Boyer',
      bgColor: '#333333',
    },
    medium: {
      image: headerLogoX2,
      width: 224,
      height: 42,
      horiPadding: 25,
      verticalPadding: 15,
      altText: 'Logo of freelance web developer Dallas Boyer',
      bgColor: '#333333',
    },
    small: {
      image: headerLogoX2,
      width: 224,
      height: 42,
      horiPadding: 10,
      verticalPadding: 5,
      altText: 'Logo of freelance web developer Dallas Boyer',
      bgColor: '#333333',
    },
  },
  footerLogo: {
    image: headerLogoX3,
    width: 336,
    height: 63,
    altText: 'Logo of freelance web developer Dallas Boyer',
    imgPadding: 10,
  },
  pages: {
    home: {
      meta: {
        title: `Web Designer and Developer Dallas Boyer in Reno ${currentYear}`,
        description: "Dallas offers freelance web design and front-end web developer in the Reno, Carson City, Lake Tahoe area. I will help you achieve your online goals.",
        keywords: ["dallas boyer", "freelance web design", "freelance web developer", "web consultant", "phone app", "web app", "reno nv", "carson city nv", "web design", "dallas", "TX"],
      },
      headerIcon: faHome,
      banner: {
        image: terminalBannerDim,
        width: 1076,
        height: 495,
        title: "Javascript Web Developer",
        subTitle: "I program websites, web apps, and phone apps from inception to completion using only core Javascript",
        action: {
          text: "Hire Me Now!",
          url: "contact",
        },
      },
      sections: [
        {
          component: "ListSection",
          isFullScreen: false,
          title: "I am skilled at client side and server side Javascript",
          subTitle: "",
          items: [
            {
              title: "Javascript ES6 and Beyond",
              // icon: faCode,
              description: <JavascriptES6andBeyondListItem />,
            },
            {
              title: "React JS",
              // icon: faCode,
              description: <ReactJsListItem />,
            },
            {
              title: "React Native",
              // icon: faCode,
              description: <ReactNativeListItem />,
            },
          ],
        },
        {
          component: "ActionSection1",
          isFullScreen: false,
          title: "An analytics web app for mining industry",
          description: "This web app was created using includes Auth0 for authentication, a java web service (API), a mongodb database, and an IOS app which collects the data.  I used React, Redux, and Auth0 to create this app.",
          image: analyticsWebAppScreenshot,
          altText: "An analytics web app for mining industry created by Dallas Boyer",
          buttonText: 'View the Analytics Web App',
          buttonURL: 'https://mineproduction-portal.herokuapp.com',
          direction: 'row'
        },
        {
          component: "ActionSection1",
          isFullScreen: false,
          title: "A Reddit like Comment Forum Web App with comment voting system",
          description: "This React web app uses Redux for global state management and React local state for specialized situations. It uses a Node JS web service for CRUD operations.  The project includes both a fronend and backend, I created the frontend portion.",
          image: commentForumWebAppScreenshot,
          altText: "A Reddit like comment forum web app with comment voting created by Dallas Boyer",
          buttonText: 'View the Comment Forum Web App',
          buttonURL: 'https://github.com/dallasboyer/comment-forum-web-app',
          direction: 'row-reverse'
        },
        {
          component: "ActionSection1",
          isFullScreen: false,
          title: "A Flashcards Android and IOS Phone App",
          description: "This phone app was programmed with React Native which allows me to create both Android and IOS phone apps simultaneously from a single code base.  I used React, React Native, and Redux.",
          image: flashcardsPhoneAppMockup,
          altText: "A Flashcards Android and IOS Phone App created by Dallas Boyer",
          buttonText: 'View the Flashcards Phone App',
          buttonURL: 'https://github.com/dallasboyer/flashcards-native-phone-app',
          direction: 'row'
        },
        {
          component: "ActionSection1",
          isFullScreen: false,
          title: "A Book Tracking Web App created in React and Redux",
          description: "This web app uses React and Redux.  It consumes a simple third party CRUD API.  The main goal is to demonstrate proper state management.",
          image: bookTrackingWebAppScreenshot,
          altText: "A book tracking web app created by Dallas Boyer",
          buttonText: 'View the Book Tracking App',
          buttonURL: 'https://github.com/dallasboyer/book-tracking-web-app',
          direction: 'row-reverse'
        },
      ],
    },
    about: {
      meta: {
        title: `Dallas Boyer makes websites, web, and phone apps ${currentYear}`,
        description: "Dallas is a professional web developer who uses javascript",
        keywords: ["dallas boyer", "freelance web design", "freelance web developer", "web consultant", "phone app", "web app", "reno nv", "carson city nv", "web design", "dallas", "TX"],
      },
      headerIcon: faUser,
      banner: {
        title: "Freelance web design and development",
        subTitle: "I employ the latest technology in all of my work",
        action: {
          text: "Hire Me",
          url: "contact"
        }
      },
      sections: [
        {
          component: "InfoSection1",
          isFullScreen: false,
          title: `An autodidact in the web development industry of ${currentYear}`,
          subTitle: "I focus on Frontend Javascript and consuming REST API's",
          description: <InfoSectionDescription1 />,
          direction: "row",
          image: profilePic,
          altText: "A placeholder image"
        },
        {
          component: "InfoSection1",
          isFullScreen: false,
          title: "As a freelance web developer it is imperative that I stay on the cutting edge",
          subTitle: "The Javascript ecosystem is strong and progressing quickly, and so am I",
          description: <InfoSectionDescription2 />,
          direction: "row-reverse",
          image: techLogos,
          altText: "A placeholder image"
        },
      ],
    },
    contact: {
      meta: {
        title: `Hire Dallas Boyer for quality websites and apps ${currentYear}`,
        description: "Contact Dallas Boyer for website, web app, or phone app design and development. (775)-781-9261",
        keywords: ["dallas boyer", "freelance web design", "freelance web developer", "web consultant", "phone app", "web app", "reno nv", "carson city nv", "web design", "dallas", "TX"],
      },
      headerIcon: faPhone,
      banner: {
        title: "Websites, web apps, or phone apps, I can make it!",
        subTitle: "Contact me and we'll make you shine online",
        // action: {
        //   text: "take action",
        //   url: "contact"
        // }
      },
    },
  },

}


// WEBPACK FOOTER //
// ./src/config/Config.js